var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenerateReportImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 19.0002H3.33333C2.8731 19.0002 2.5 18.6271 2.5 18.1668V3.16683C2.5 2.7066 2.8731 2.3335 3.33333 2.3335H16.6667C17.1269 2.3335 17.5 2.7066 17.5 3.16683V18.1668C17.5 18.6271 17.1269 19.0002 16.6667 19.0002ZM15.8333 17.3335V4.00016H4.16667V17.3335H15.8333ZM5.83333 5.66683H9.16667V9.00016H5.83333V5.66683ZM5.83333 10.6668H14.1667V12.3335H5.83333V10.6668ZM5.83333 14.0002H14.1667V15.6668H5.83333V14.0002ZM10.8333 6.50016H14.1667V8.16683H10.8333V6.50016Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateReportImage);
export default __webpack_public_path__ + "static/media/generate-report-image.b0e0799c7dc26f04227888ccfd5bf8ea.svg";
export { ForwardRef as ReactComponent };